import { atom, getDefaultStore } from 'jotai'

const store = getDefaultStore()

type BannerType = 'default' | 'discount'
export const headerBannerAtom = atom<boolean>(false)
export const setHeaderBanner = (show: boolean) => {
  store.set(headerBannerAtom, show)
}
export const headerBannerTypeAtom = atom<BannerType>('default')
export const setHeaderBannerType = (bannerType: BannerType) => {
  store.set(headerBannerTypeAtom, bannerType)
}

export const headerCreditPillAtom = atom<boolean>(false)
export const setHeaderCreditPill = (show: boolean) => {
  store.set(headerCreditPillAtom, show)
}
